// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131008/js/" + chunkId + "." + {"44":"067a1446","225":"57a34824","481":"2cdb0968","486":"7d59e5e4","770":"d8716e87"}[chunkId] + ".0.9192893744187897.chunk.js";
};